module.exports = __webpack_public_path__ + "static/media/CheckMarkItem.c23e8c99.svg";